module.exports = __webpack_public_path__ + "static/media/tandc.49e576ba.png";